import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useCookies } from 'react-cookie';
import { Button, Icons } from '../';
import styles from './cart-button.module.scss';

const CART_COUNT_COOKIE = 'cart_number_of_quotes';

const CartButton = ({ showLabel, ...props }) => {
  const [cookies] = useCookies();
  const count = cookies[CART_COUNT_COOKIE];

  return (
    // eslint-disable-next-line react/prop-types
    <div className={cn(styles.button, props.className)}>
      <Button
        href={`${window.location.origin}/shopping_cart`}
        onClick={props.onClick}
      >
        <div className={styles.content}>
          {showLabel && (
            <FormattedMessage id="buttons.cart" defaultMessage="Cart" />
          )}
          <Icons.CartOutline className={styles.icon} />
          {count > 0 && <div className={styles.count}>{count}</div>}
        </div>
      </Button>
    </div>
  );
};

CartButton.propTypes = {
  /** Show the text label in the button */
  showLabel: PropTypes.bool,
  /** A callback function called when clicking the Cart button */
  onClick: PropTypes.func,
};

CartButton.defaultProps = {
  showLabel: false,
  onClick: () => {},
};

export default CartButton;
